import React, { HTMLAttributes } from 'react'

import { Text, theme } from '@hhgtech/hhg-components'
import { Badge } from '@hhgtech/hhg-components/mantine'

export const _PremiumBadge = (props: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div {...props}>
      <Badge
        styles={{
          root: {
            padding: '4px 8px 4px 4px',
            backgroundColor: theme.colors.yellow50,
          },
          inner: {
            textTransform: 'initial',
          },
          leftSection: {
            lineHeight: 'initial',
            display: 'flex',
            alignItems: 'center',
          },
        }}
        size="lg"
        radius="xl"
        leftSection={
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="10" cy="10" r="10" fill="#FE921D" />
            <path
              d="M10 4.75C9.84529 4.75 9.69691 4.81146 9.58752 4.92085C9.47812 5.03025 9.41666 5.17862 9.41666 5.33333C9.41654 5.42622 9.4386 5.51778 9.48101 5.60042C9.52342 5.68306 9.58495 5.75437 9.66048 5.80843L7.86832 8.31722L4.71923 7.2679C4.73935 7.20844 4.74974 7.14611 4.74999 7.08333C4.74999 6.92862 4.68854 6.78025 4.57914 6.67085C4.46974 6.56146 4.32137 6.5 4.16666 6.5C4.01195 6.5 3.86358 6.56146 3.75418 6.67085C3.64479 6.78025 3.58333 6.92862 3.58333 7.08333C3.58333 7.23804 3.64479 7.38642 3.75418 7.49581C3.86358 7.60521 4.01195 7.66667 4.16666 7.66667C4.20923 7.66636 4.25164 7.66139 4.29313 7.65186L5.13053 11.4196C5.24895 11.9533 5.72213 12.3333 6.26871 12.3333H13.7301C14.2767 12.3333 14.751 11.9533 14.8695 11.4196L15.7069 7.65299C15.7484 7.66215 15.7908 7.66673 15.8333 7.66667C15.988 7.66667 16.1364 7.60521 16.2458 7.49581C16.3552 7.38642 16.4167 7.23804 16.4167 7.08333C16.4167 6.92862 16.3552 6.78025 16.2458 6.67085C16.1364 6.56146 15.988 6.5 15.8333 6.5C15.6786 6.5 15.5302 6.56146 15.4208 6.67085C15.3115 6.78025 15.25 6.92862 15.25 7.08333C15.2503 7.14611 15.2606 7.20844 15.2808 7.2679L12.1317 8.31722L10.3384 5.80729C10.414 5.75347 10.4756 5.68239 10.5182 5.59996C10.5608 5.51753 10.5831 5.42612 10.5833 5.33333C10.5833 5.17862 10.5219 5.03025 10.4125 4.92085C10.3031 4.81146 10.1547 4.75 10 4.75V4.75ZM5.91666 13.5C5.59466 13.5 5.33333 13.7613 5.33333 14.0833C5.33333 14.4053 5.59466 14.6667 5.91666 14.6667H14.0833C14.4053 14.6667 14.6667 14.4053 14.6667 14.0833C14.6667 13.7613 14.4053 13.5 14.0833 13.5H5.91666Z"
              fill="white"
            />
          </svg>
        }
      >
        <Text size="s5" color={theme.colors.yellow800}>
          Premium
        </Text>
      </Badge>
    </div>
  )
}

export const PremiumBadge = React.memo(_PremiumBadge)
